import { render, staticRenderFns } from "./IconRemoveReferral.vue?vue&type=template&id=2929dc0c&"
import script from "./IconRemoveReferral.vue?vue&type=script&lang=ts&"
export * from "./IconRemoveReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports